// Import Assets
import profile from '../assets/profile.jpg';

const Header = () => {
    return (
        <section className='header'>
            <img src={profile} alt="Utkarsh Hadgekar" />

            <div className='header__content'>
                <h1>Hi, I'm Utkarsh Hadgekar👋</h1>
                <p>Blockchain Developer</p>
                {/* <a href="mailto:utkarshuh16@gmail.com" className='button' >Get In Touch</a> */}
            </div>
        </section>
    );
}

export default Header;